import { FC, SVGProps } from 'react';

export const AttentionIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6ZM4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15 20.8889C15 20.3366 15.4477 19.8889 16 19.8889H16.0122C16.5645 19.8889 17.0122 20.3366 17.0122 20.8889V20.9011C17.0122 21.4534 16.5645 21.9011 16.0122 21.9011H16C15.4477 21.9011 15 21.4534 15 20.9011V20.8889Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 10.1111C16.5523 10.1111 17 10.5588 17 11.1111V16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V11.1111C15 10.5588 15.4477 10.1111 16 10.1111Z"
			fill="currentColor"
		/>
	</svg>
);
